import React, { useEffect, useState } from 'react';
import { getBiharElectionNews } from '../../services/api';
import './BiharElectionNews.css';

const ArticleCard = ({ article, index }) => {
  const creator = article.source_name ?? 'News Bureau';

  const handleImageError = (e) => {
    e.target.style.display = 'none';
  };

  return (
    <article className="article-card" style={{ animationDelay: `${index * 0.1}s` }}>
      <div className="article-image-wrapper">
        {article.image_url && (
          <img
            src={article.image_url}
            alt={article.title}
            className="article-image"
            onError={handleImageError}
          />
        )}
        <div className="article-overlay">
          <span className="category-badge">{article.category || 'General'}</span>
        </div>
      </div>

      <div className="article-content">
        <div className="article-header">
          <a
            href={article.link}
            target="_blank"
            rel="noopener noreferrer"
            className="article-title"
          >
            {article.title}
          </a>
          <span className="article-language">{article.language}</span>
        </div>

        <p className="article-description">
          {article.description || article.content || 'No description available'}
        </p>

        <div className="article-meta">
          <div className="meta-left">
            <span className="source-badge">
              <span className="source-dot"></span>
              {creator}
            </span>
            <span className="separator">•</span>
            <span className="publish-time">
              {article.pubDate &&
                new Date(article.pubDate).toLocaleString('hi-IN', {
                  dateStyle: 'short',
                  timeStyle: 'short',
                })}
            </span>
          </div>
        </div>

        <a
          href={article.link}
          target="_blank"
          rel="noopener noreferrer"
          className="read-more"
        >
          Read Full Story →
        </a>
      </div>
    </article>
  );
};

const BiharElectionNews = () => {
  const [newsData, setNewsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [lastUpdated, setLastUpdated] = useState(null);

  useEffect(() => {
    const fetchNews = async () => {
      setLoading(true);
      setError('');
      try {
        const data = await getBiharElectionNews();
        setNewsData(data);
        setLastUpdated(new Date());
      } catch (err) {
        setError(err?.message || 'Failed to load news');
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
    const interval = setInterval(fetchNews, 30 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const articles = newsData?.results || [];

  return (
    <div className="bihar-news-page">
      <section className="news-section">
        {/* Hero Header */}
        <div className="news-hero">
          <div className="hero-content">
            <div className="hero-badge">📰 Election Coverage</div>
            <h1 className="hero-title">बिहार चुनाव समाचार</h1>
            <p className="hero-subtitle">
              Real-time updates on Bihar Legislative Assembly Elections 2025
            </p>
            {newsData && (
              <div className="hero-stats">
                <div className="stat">
                  <span className="stat-number">{newsData.totalResults}</span>
                  <span className="stat-label">News Articles</span>
                </div>
                {lastUpdated && (
                  <div className="stat">
                    <span className="stat-number">
                      {lastUpdated.toLocaleTimeString('hi-IN', { timeStyle: 'short' })}
                    </span>
                    <span className="stat-label">Last Updated</span>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Loading State */}
        {loading && (
          <div className="loading-container">
            <div className="loader">
              <div className="loader-inner"></div>
            </div>
            <p className="loading-text">समाचार लोड हो रहे हैं...</p>
          </div>
        )}

        {/* Error State */}
        {error && (
          <div className="error-container">
            <div className="error-icon">⚠️</div>
            <h3>Error Loading News</h3>
            <p>{error}</p>
            <button
              onClick={() => window.location.reload()}
              className="retry-btn"
            >
              Try Again
            </button>
          </div>
        )}

        {/* Content State */}
        {!loading && !error && (
          <>
            {articles.length > 0 ? (
              <div className="articles-grid">
                {articles.map((article, idx) => (
                  <ArticleCard
                    key={article.article_id}
                    article={article}
                    index={idx}
                  />
                ))}
              </div>
            ) : (
              <div className="empty-state">
                <div className="empty-icon">📭</div>
                <h3>No News Available</h3>
                <p>कोई समाचार नहीं मिला।</p>
              </div>
            )}
          </>
        )}
      </section>
    </div>
  );
};

export default BiharElectionNews;
